export default "__VITE_ASSET__BcHGgRHM__"